export default "__VITE_ASSET__DkkQUie4__"